<template>
  <a v-if="item.type === 'color'"
     :title="item.alt"
     :href="item.active ? 'javascript: void(0)' : item.url"
     class="option-item__color"
     :class="{'option-item__color--active': item.active, 'option-item__color--disabled': !item.available}">
    <span :style="'background: ' + this.gradientBg" class="option-item__color-preview"></span>
  </a>
  <a v-else-if="item.type === 'text'"
     :title="item.alt"
     :href="item.active ? 'javascript: void(0)' : item.url"
     class="option-item__text"
     :class="{'option-item__text--active': item.active, 'option-item__text--disabled': !item.available}">
    <span class="option-item__text-content">
      {{ item.value }}
    </span>
  </a>
</template>

<script>
export default {
  name: 'ProductOptionItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    gradientBg () {
      return this.item.value.split(',')
        .map(function (val, idx, arr) {
          return (idx === 0 ? 'linear-gradient(to right, ' : '') + val.trim() + ' ' + (100 / arr.length) * idx + '% ' + ((100 / arr.length) * idx + 100 / arr.length) + '%' + (idx + 1 === arr.length ? ')' : '')
        }).join(', ')
    }
  }
}
</script>

<style scoped lang="sass">

.option-item__color
  position: relative
  display: block
  border: 1px solid $nd-border-color
  border-radius: 3px
  padding: 3px

  &:hover
    border-color: $placeholder-color

  &--disabled:before
    content: ''
    position: absolute
    top: 12px
    left: -5px
    display: block
    width: 35px
    height: 1px
    background-color: $main-color
    transform: rotate(45deg)

  &--active
    border-color: $main-color

    &:hover
      border-color: $main-color

.option-item__color-preview
  display: block
  width: 19px
  height: 19px
  border: 1px solid rgba(236, 236, 236, 1)
  border-radius: 2px

.option-item__text
  display: block
  border: 1px solid $nd-border-color
  border-radius: 3px
  padding: 4px 9px

  &:hover
    border-color: $placeholder-color

  &--disabled
    background-color: #F3F3F3
    border-color: #F3F3F3

  &--active
    border-color: $main-color

    &:hover
      border-color: $main-color

.option-item__text--disabled .option-item__text-content
  color: $placeholder-color

.option-item__text-content
  font-size: 14px
  line-height: 120%
  color: $text-color

</style>
